import React from "react";
import { Progress, Space, Typography, Tag } from "antd";
import {
  ClockCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const SLAProgress = ({ callRequest }) => {
  const getSLAStatus = (callRequest) => {
    const now = new Date();
    const slaDueAt = new Date(callRequest.slaDueAt);
    const minutesLeft = Math.floor((slaDueAt - now) / (1000 * 60));

    if (minutesLeft <= 0) {
      return { status: "breached", minutesLeft: 0, color: "#ff4d4f" };
    } else if (minutesLeft <= 15) {
      return { status: "critical", minutesLeft, color: "#ff4d4f" };
    } else if (minutesLeft <= 30) {
      return { status: "warning", minutesLeft, color: "#fa8c16" };
    } else {
      return { status: "normal", minutesLeft, color: "#52c41a" };
    }
  };

  const slaStatus = getSLAStatus(callRequest);

  const getProgressColor = () => {
    switch (slaStatus.status) {
      case "breached":
        return "#ff4d4f";
      case "critical":
        return "#ff4d4f";
      case "warning":
        return "#fa8c16";
      default:
        return "#52c41a";
    }
  };

  const getProgressPercent = () => {
    if (slaStatus.status === "breached") return 100;

    const total =
      new Date(callRequest.slaDueAt).getTime() -
      new Date(callRequest.requestedAt).getTime();
    const elapsed = Date.now() - new Date(callRequest.requestedAt).getTime();

    return Math.min(100, Math.max(0, (elapsed / total) * 100));
  };

  const getStatusIcon = () => {
    if (slaStatus.status === "breached") {
      return <ExclamationCircleOutlined style={{ color: "#ff4d4f" }} />;
    }
    return <ClockCircleOutlined style={{ color: slaStatus.color }} />;
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Space>
        {getStatusIcon()}
        <Text strong>SLA Progress</Text>
        <Tag color={slaStatus.color}>
          {slaStatus.minutesLeft > 0
            ? `${slaStatus.minutesLeft}m left`
            : "Overdue"}
        </Tag>
      </Space>

      <Progress
        percent={getProgressPercent()}
        strokeColor={getProgressColor()}
        showInfo={false}
        size="small"
      />

      <Text type="secondary" style={{ fontSize: "12px" }}>
        Due: {new Date(callRequest.slaDueAt).toLocaleTimeString()}
      </Text>
    </Space>
  );
};

export default SLAProgress;
